import React, { createContext, FC, ReactNode } from 'react';

import { OrganizationBasicInfoQuery } from '../types/api.graphql';

type Nullable<T> = T | null;

export type OrganizationData = OrganizationBasicInfoQuery['organization'];

interface OrganizationContextProps {
  organizationData: Nullable<OrganizationData>;
  organizationId: Nullable<string>;
  setOrganizationData: (organizationName: OrganizationData) => void;
  setOrganizationId: (organizationId: string) => void;
  organizationDataLoading: boolean;
  setOrganizationDataLoading: (loading: boolean) => void;
  resetSelectedOrganization: () => void;
}

interface OrganizationProviderProps {
  children: ReactNode;
}

const OrganizationContext = createContext<OrganizationContextProps>({
  organizationData: null,
  setOrganizationData: undefined,
  organizationId: null,
  setOrganizationId: undefined,
  organizationDataLoading: false,
  setOrganizationDataLoading: undefined,
  resetSelectedOrganization: undefined,
});

export const OrganizationProvider: FC<OrganizationProviderProps> = ({ children }) => {
  const [organizationData, setOrganizationData] = React.useState<Nullable<OrganizationData>>(null);
  const [organizationDataLoading, setOrganizationDataLoading] = React.useState<boolean>(true);
  const [organizationId, setOrganizationId] = React.useState<Nullable<string>>(null);

  const resetSelectedOrganization = () => {
    setOrganizationData(null);
    setOrganizationDataLoading(true);
    setOrganizationId(null);
  };

  return (
    <OrganizationContext.Provider
      value={{
        organizationData,
        setOrganizationData,
        organizationId,
        setOrganizationId,
        organizationDataLoading,
        setOrganizationDataLoading,
        resetSelectedOrganization,
      }}
    >
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganizationContext: () => OrganizationContextProps = () => {
  return React.useContext(OrganizationContext);
};
